import React from 'react';
import { shallowEqual, useSelector } from 'react-redux';

function HotIssues(): JSX.Element {
    const {
        base_config: { hot_issues }
    } = useSelector(
        ({ IndexReducer }) => ({
            base_config: IndexReducer.base_config
        }),
        shallowEqual
    );
    const parseStyle = (styleString) => {
        const style = {};
        styleString?.split(';').forEach((rule) => {
            if (rule.trim()) {
                const [key, value] = rule.split(':').map((item) => item.trim());
                if (key && value) {
                    // 转换 CSS 属性名为驼峰式（如 font-size → fontSize）
                    const reactKey = key.replace(/-(\w)/g, (_, letter) => letter.toUpperCase());
                    style[reactKey] = value;
                }
            }
        });
        return style;
    };
    return (
        <div className="im-hot-issues">
            <div className="issues-title">热门问题</div>
            <ul className="issues-list">
                {hot_issues?.map((item, index) => (
                    <li key={`issues${index + 1}`}>
                        <a
                            target="_blank"
                            rel="noreferrer"
                            style={parseStyle(item.style)}
                            href={item.url}
                        >
                            {item.name}
                        </a>
                    </li>
                ))}
            </ul>
        </div>
    );
}

export default HotIssues;
